import React, { useState, useEffect } from "react";
import { Modal, Descriptions, Typography, Empty } from "antd"
import { useAtom } from "jotai";
import { isSubstanceInfoModalOpenState, infoModalSubstanceState, allSubstancesDataState } from '../stateManagement/commonState';
const { Text } = Typography;

const SubstanceInfoModal = () => {

    const [isSubstanceInfoModalOpen, setIsSubstanceInfoModalOpen] = useAtom(isSubstanceInfoModalOpenState);
    const [infoModalSubstance, setInfoModalSubstance] = useAtom(infoModalSubstanceState);
    const [allSubstancesData] = useAtom(allSubstancesDataState);
    const [substanceInfo, setSubstanceInfo] = useState(null);

    useEffect(() => {
        fetchPubchemDataAndUpdateInfo(infoModalSubstance);
    }, [infoModalSubstance]);

    const fetchPubchemDataAndUpdateInfo = async (substance) => {

        let substanceData = allSubstancesData[substance];
        if (substanceData?.info) {
            setSubstanceInfo([
                ...(substanceData.info.overview ? [{
                    key: 'overview',
                    label: 'Overview',
                    children: <Text style={{ whiteSpace: 'pre-line' }}>{substanceData.info.overview}</Text>
                }] : []),
                ...(substanceData.info.effects ? [{
                    key: 'effects',
                    label: 'Effects',
                    children: <Text style={{ whiteSpace: 'pre-line' }}>{substanceData.info.effects}</Text>
                }] : []),
                ...(substanceData.info.safety ? [{
                    key: 'safety',
                    label: 'Safety',
                    children: <Text style={{ whiteSpace: 'pre-line' }}>{substanceData.info.safety}</Text>
                }] : [])
            ]);
        } else {
            setSubstanceInfo(null);
        }
    }

    return (
        <Modal
            open={isSubstanceInfoModalOpen}
            onCancel={() => setIsSubstanceInfoModalOpen(false)}
            footer={null}
        >
            {substanceInfo ? (
                <Descriptions
                    title={infoModalSubstance}
                    bordered={true}
                    column={1}
                    size="small"
                    layout="vertical"
                    items={substanceInfo}
                />
            ) : (
                <>
                    <Descriptions
                        title={infoModalSubstance}
                        bordered={true}
                        column={1}
                        size="small"
                        layout="vertical"
                    />
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"No information available"}
                        style={{ height: '145px', margin: '0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} />
                </>
            )}
        </Modal>
    )
}

export default SubstanceInfoModal;